import React from 'react';

import {Wizard, WizardStep} from '../../wizard/Wizard';
import {UploadSchemaContextProvider} from "./context/UploadSchemaContext";
import SelectSchemaStep from "./SelectSchemaStep";
import SaveSchemaStep from "./SaveSchemaStep";
import ActivateSchemaStep from "./ActivateSchemaStep";
import CompleteUploadSchemaStep from "./CompleteUploadSchemaStep";
import {WorkbenchStateContext} from "../../context/WorkbenchContext";

import './UploadSchemaWizard.scss';

/**
 * Integrates the Wizard component. This component also plays role of a wizard state
 * context provider. All step implementations can use the state from {@link UploadSchemaContext} by
 * declaring the contextType like this
 * <code>SelectSchemaStep.contextType = UploadSchemaContext;</code>
 * then the context can be accessed through a <code>this.context</code> call.
 */
class UploadSchemaWizard extends React.Component {

  static contextType = WorkbenchStateContext;

  wizardSteps: Array<WizardStep> = [
    {name: 'Select Schema', component: SelectSchemaStep, descr: ''},
    {name: 'Save Schema', component: SaveSchemaStep, descr: ''},
    {name: 'Activate Schema', component: ActivateSchemaStep, descr: ''},
    {name: 'Done', component: CompleteUploadSchemaStep, descr: ''}
  ];

  render() {
    return (
      <UploadSchemaContextProvider configurations={this.context.configurations}>
        <Wizard steps={this.wizardSteps} className="UploadSchemaWizard"/>
      </UploadSchemaContextProvider>
    )
  }
}

export function UploadSchemaWizardLeavingConfirmationMessage() {
  return <p>Are you sure you want to leave this page? The Upload
    Schema Wizard progress will be lost!</p>
}

export default UploadSchemaWizard;
